var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaypalpay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6072 11.3013C25.803 12.5929 26.8364 14.9179 26.8364 17.5013C26.8364 20.7304 23.6072 23.3138 20.378 23.3138H17.0197L16.2447 27.9638C16.1843 28.2599 16.022 28.5255 15.786 28.7143C15.55 28.9031 15.2552 29.0032 14.953 28.9971H11.4655C11.3687 28.9991 11.2726 28.9792 11.1845 28.939C11.0963 28.8988 11.0184 28.8393 10.9563 28.7649C10.8943 28.6904 10.8498 28.603 10.8262 28.509C10.8025 28.4151 10.8003 28.317 10.8197 28.2221",
    stroke: "#FF6019",
    strokeWidth: 2.66406,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.915 18.7935H17.1442C20.3734 18.7935 23.6025 15.5643 23.6025 12.3352C23.6025 8.46016 21.1484 5.87683 17.1442 5.87683H10.04C9.39421 5.87683 8.74837 6.52266 8.74837 7.1685L6.16504 25.2518C6.16504 25.8977 6.81087 26.5435 7.45671 26.5435H11.0734L12.6234 20.0852C12.7525 19.3102 13.14 18.7935 13.915 18.7935Z",
    stroke: "#6921C4",
    strokeWidth: 2.66406,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypalpay);
export default __webpack_public_path__ + "static/media/paypalpay.d56ddd09.svg";
export { ForwardRef as ReactComponent };